export const powerDefenseCosts: { [power: number]: number } = {
  1: 0,
  2: 80,
  3: 140,
  4: 200,
  5: 280,
  6: 330,
  7: 380,
};
